import React from "react";

export default function Button({ children, style = {}, loading = false, ...props }) {
  return (
    <button
      style={{
        border: "none",
        borderRadius: 12,
        padding: "10px 16px",
        background: "var(--primary)",
        color: "#fff",
        fontWeight: 700,
        fontSize: 15,
        cursor: loading ? "not-allowed" : "pointer",
        opacity: loading ? 0.7 : 1,
        ...style,
      }} 
      disabled={loading}
      {...props}
    >
      {loading ? "Processing..." : children}
    </button>
  );
}
